// extracted by mini-css-extract-plugin
export var lg = "_2j-4";
export var md = "_2j-3";
export var sm = "_2j-2";
export var xs = "_2j-1";
export var xxs = "_2j-0";